var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudienceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9992 14.7184C35.8792 14.6984 35.7392 14.6984 35.6192 14.7184C32.8592 14.6184 30.6592 12.3584 30.6592 9.55844C30.6592 6.69844 32.9592 4.39844 35.8192 4.39844C38.6792 4.39844 40.9792 6.71844 40.9792 9.55844C40.9592 12.3584 38.7592 14.6184 35.9992 14.7184Z",
    stroke: "#FECC00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9399 29.2787C36.6799 29.7387 39.6999 29.2587 41.8199 27.8387C44.6399 25.9587 44.6399 22.8787 41.8199 20.9987C39.6799 19.5788 36.6199 19.0987 33.8799 19.5787",
    stroke: "#FECC00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.939 14.7184C12.059 14.6984 12.199 14.6984 12.319 14.7184C15.079 14.6184 17.279 12.3584 17.279 9.55844C17.279 6.69844 14.979 4.39844 12.119 4.39844C9.25898 4.39844 6.95898 6.71844 6.95898 9.55844C6.97898 12.3584 9.17898 14.6184 11.939 14.7184Z",
    stroke: "#FECC00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 29.2787C11.2599 29.7387 8.23988 29.2587 6.11988 27.8387C3.29988 25.9587 3.29988 22.8787 6.11988 20.9987C8.25988 19.5788 11.3199 19.0987 14.0599 19.5787",
    stroke: "#FECC00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9993 29.656C23.8793 29.636 23.7393 29.636 23.6193 29.656C20.8593 29.556 18.6592 27.296 18.6592 24.496C18.6592 21.636 20.9593 19.3359 23.8193 19.3359C26.6793 19.3359 28.9793 21.656 28.9793 24.496C28.9593 27.296 26.7593 29.576 23.9993 29.656Z",
    stroke: "#FECC00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1795 35.9611C15.3595 37.8411 15.3595 40.9211 18.1795 42.8011C21.3795 44.9411 26.6195 44.9411 29.8195 42.8011C32.6395 40.9211 32.6395 37.8411 29.8195 35.9611C26.6395 33.8411 21.3795 33.8411 18.1795 35.9611Z",
    stroke: "#FECC00",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceIcon);
export default __webpack_public_path__ + "static/media/audience-icon.aaac9cb69e821875d15b490dca76af45.svg";
export { ForwardRef as ReactComponent };